import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AsyncSelect from 'react-select/async';


export const CustomerCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    /* API Call Post Method */
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    //Customer create
    const [names, setNames] = useState("");
    const [emails, setEmails] = useState("");
    const [contactNumber1s, setContactNumber1s] = useState("");
    const [contactNumber2s, setContactNumber2s] = useState("");
    const [addressline1s, setAddressLine1s] = useState("");
    const [addressline2s, setAddressLine2s] = useState("");
    const [location, setLocation] = useState("");
    const [customernote, setCustomernote] = useState("");
    const [proofNo, setProofNo] = useState("");
    const [cautionDeposite, setCautionDeposite] = useState("");
    const [rentAmount, setRentAmount] = useState("");

    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [RentDate, setRentDate] = useState(new Date().toISOString().split('T')[0]);
    const [DateOfJoining, setDateOfJoining] = useState(new Date().toISOString().split('T')[0]);
    const [DateOfLeaving, setDateOfLeaving] = useState(new Date().toISOString().split('T')[0]);



    //IDCard type

    const [selectedIDCard, setSelectedIDCard] = useState("");
    const [cardTypeOptions, setcardTypeOptions] = useState([]);
    const [selectedcardType, setSelectedcardType] = useState("");

    const fetchCardTypes = async () => {
        try {
            const response = await fetchData('CustomerApi', `/${companyId}/${companyId}`, token);
            const options = response.map(Card => ({
                value: Card.id,
                label: Card.cardName
            }));
            setcardTypeOptions(options);
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };

    const handlecardTypeChange = (selectedOption) => {
        setSelectedcardType(selectedOption);
    };

    useEffect(() => {
        fetchCardTypes();
    }, []);



    const [roomTypeOptions, setRoomTypeOptions] = useState([]);
    const [selectedRoomType, setSelectedRoomType] = useState("");
    const [selectedRoomRent, setSelectedRoomRent] = useState("");
    const [roomName, setRoomName] = useState([]);

    // Fetch room types
    const fetchRoomTypes = async () => {
        try {
           // const response = await fetchData('RoomApi', `/${companyId}`);
           const response = await fetchData('CustomerApi', `/RommDetails/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(rooms => ({
                    value: rooms.ID,
                    label: rooms.Name
                }));
                const rooms = response.response_data;
                setRoomName(rooms);

                setRoomTypeOptions(options);
            }
            console.log(response);
        } catch (error) {
            console.error('Error fetching Room Types:', error);
        }
    };


    const handleroomChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedRoomType(selectedOption);

            const selectedRoomData = roomName.find(customer => customer.ID === selectedOption.value);
            if (selectedRoomData) {
                setRentAmount(selectedRoomData.RentAmount);
            }
        }
    };


    // Fetch room types on component mount
    useEffect(() => {
        fetchRoomTypes();
    }, []);


    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!names || !contactNumber1s) {
            setErrorMessages("All fields are required!");
            setIsLoading(false);
            return;
        }

        try {

            const CustomerCreateData = {
                CompanyId: companyId,
                RoomId: selectedRoomType.value,
                IdCardId: selectedcardType.value,
                Name: names,
                //CustomerTypeID: selectedCustomerTypeId,
                ContactNumber1: contactNumber1s,
                ContactNumber2: contactNumber2s,
                AddressLine1: addressline1s,
                AdressLine2: addressline2s,
                Location: location,
                Email: emails,
                CustomerRemark: customernote,
                ProofNo: proofNo,
                CautionDeposite: cautionDeposite,
                RentAmount: rentAmount,
                RentDate: RentDate,
                DateOfJoining: DateOfJoining,
                DateOfLeaving: DateOfLeaving,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            postData('CustomerApi', CustomerCreateData, token)
                .then((response) => {
                    console.log('Customer Created success:', response);
                    setNames("");
                    setContactNumber1s("");
                    setContactNumber2s("");
                    setAddressLine1s("");
                    setAddressLine2s("");
                    setCustomernote("");
                    setProofNo("");
                    setCautionDeposite("");
                    setDateOfJoining("");
                    setDateOfLeaving("");
                    setRentAmount("");
                    setSelectedIDCard("");
                    setSelectedRoomType("");
                    setEmails("");
                    setLocation("");
                    setRentDate("");

                    setSuccessMessages("customer Created successful!");
                    setErrorMessages(""); // Clear error message on success
                    history.push('/customerIndex');

                    setTimeout(() => {
                        setSuccessMessages("");
                    }, 3000); // 3 seconds
                })
                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                });


        }
        catch (error) {
            console.error('Item Create error:', error);
        }
    };

    /* End API */


    return (

        <Fragment>
            <div className="w-full max-w-full md:max-w-sm container mt-6 mx-auto px-4">

                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
                        <h6 className='productHead flex-grow linkcolor text-center md:text-left' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                            CUSTOMER CREATE
                        </h6>
                        <div className='flex flex-col md:flex-row md:items-center md:ml-4'>
                            <Tooltip title="Exit">
                                <Link to="/customerindex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                    <Button style={{ color: 'brown', fontWeight: 'bolder', marginBottom: '10px' }}>
                                        Back To List <ArrowForwardIosIcon />
                                    </Button>
                                </Link>
                            </Tooltip>
                            <Tooltip title="SAVE">
                                <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder', marginLeft: '10px',marginTop:'-10px' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                                </Button>
                            </Tooltip>
                        </div>
                    </div>
                    {errorMessages && <p className="text-red-500 text-center">{errorMessages}</p>}
                    {successMessages && <p className="text-green-500 text-center">{successMessages}</p>}
                    <br />

                    <div className="w-full mb-4 flex flex-col md:flex-row">

                        <div className="w-full md:w-1/2 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="Name">
                                Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={names}
                                onChange={(e) => setNames(e.target.value)}
                                type="text"
                                placeholder="Enter Name"
                            />
                        </div>

                        <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="contactNumber1">
                                ContactNo:1
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={contactNumber1s}
                                onChange={(e) => {
                                    const input = e.target.value.replace(/\D/g, '');
                                    if (input.length <= 15) {
                                        setContactNumber1s(input);
                                    }
                                }}
                                type="text"
                                placeholder="Contact Number 1"
                            />
                        </div>

                        <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="contactNumber2">
                                ContactNo:2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={contactNumber2s}
                                onChange={(e) => {
                                    const input = e.target.value.replace(/\D/g, '');
                                    if (input.length <= 15) {
                                        setContactNumber2s(input);
                                    }
                                }}
                                type="text"
                                placeholder="Contact Number 2"
                            />
                        </div>

                        <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="email">
                                Email
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={emails} onChange={(e) => setEmails(e.target.value)}
                                type="text"
                                placeholder="Email"
                            />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex flex-col md:flex-row">

                        <div className="w-full md:w-1/2 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="AddressLine1">
                                Address Line 1
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={addressline1s} onChange={(e) => setAddressLine1s(e.target.value)}
                                type="text"
                                placeholder="Address Line 1"
                            />
                        </div>

                        <div className="w-full md:w-1/2 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="AddressLine2">
                                Address Line 2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={addressline2s} onChange={(e) => setAddressLine2s(e.target.value)}
                                type="text"
                                placeholder="Address Line 2"
                            />
                        </div>

                        <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="Location">
                                Location
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                                type="text"
                                placeholder="Location"
                            />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex flex-col md:flex-row">

                        <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                ID PROOF
                            </label>
                            <Select
                                value={selectedcardType}
                                onChange={handlecardTypeChange}
                                options={cardTypeOptions}
                                placeholder="ID PROOF"
                                isSearchable
                            />
                        </div>

                        {selectedcardType && (
                            <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                                <label className="block tracking-wide text-black text-base mb-2" htmlFor="ProofNo">
                                    ProofNo
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={proofNo}
                                    onChange={(e) => setProofNo(e.target.value)}
                                    type="text"
                                    placeholder="ProofNo"
                                />
                            </div>
                        )}

                        <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Room
                            </label>
                            <Select
                                value={selectedRoomType}
                                onChange={handleroomChange}
                                options={roomTypeOptions}
                                placeholder="Select Room"
                                isSearchable
                            />
                        </div>

                        {selectedRoomType && (
                            <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                                <label className="block tracking-wide text-black text-base mb-2" htmlFor="RentAmount">
                                    Rent Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={rentAmount}
                                    onChange={(e) => setRentAmount(e.target.value)}
                                    type="text"
                                    placeholder="Enter Rent Amount"
                                    style={{ backgroundColor: 'white' }}
                                />
                            </div>
                        )}

                        {selectedRoomType && (
                            <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                                <label className="block tracking-wide text-black text-base mb-2" htmlFor="RentDate">
                                    RentDate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={RentDate}
                                    onChange={(e) => setRentDate(e.target.value)}
                                    type="date"
                                    placeholder="RentDate"
                                />
                            </div>
                        )}

                    </div>

                    <div className="w-full mb-4 flex flex-col md:flex-row">

                        <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="DateOfJoining">
                                DateOfJoining
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={DateOfJoining}
                                onChange={(e) => setDateOfJoining(e.target.value)}
                                type="date"
                                placeholder="DateOfJoining"
                            />
                        </div>

                        <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="DateOfLeaving">
                                DateOfLeaving
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={DateOfLeaving}
                                onChange={(e) => setDateOfLeaving(e.target.value)}
                                type="date"
                                placeholder="DateOfLeaving"
                            />
                        </div>

                        <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="CautionDeposite">
                                CautionDeposit
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={cautionDeposite}
                                onChange={(e) => setCautionDeposite(e.target.value)}
                                type="text"
                                placeholder="CautionDeposite"
                            />
                        </div>

                        <div className="w-full md:w-4/5 mb-4 md:mb-0 md:mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="CustomerRemark">
                                Customer Remark
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={customernote}
                                onChange={(e) => setCustomernote(e.target.value)}
                                type="text"
                                placeholder="Enter Customer Remark"
                            />
                        </div>

                    </div>

                </form>

            </div>
        </Fragment>
    );
}


